import { render } from "./DashboardPurchase.vue?vue&type=template&id=1ac8d4aa&scoped=true"
import script from "./DashboardPurchase.vue?vue&type=script&lang=js"
export * from "./DashboardPurchase.vue?vue&type=script&lang=js"

import "./DashboardPurchase.vue?vue&type=style&index=0&id=1ac8d4aa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ac8d4aa"]])

export default __exports__